import { render } from "./OrganizationTree.vue?vue&type=template&id=d054c18c&scoped=true"
import script from "./OrganizationTree.vue?vue&type=script&lang=js"
export * from "./OrganizationTree.vue?vue&type=script&lang=js"

import "./OrganizationTree.vue?vue&type=style&index=0&id=d054c18c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d054c18c"]])

export default __exports__